/**
 * Return The App component, wrapped in a BrowserRouter
 *
 * A BrowserRouter is used to wrap the AppComponent, which contains the routes for the app.
 * See https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/BrowserRouter.md
 */

import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BreakpointsProvider } from 'ctm-util-functions';
import { App } from './app';

const AppProvider = ({ routes }) => (
    <BrowserRouter>
        <BreakpointsProvider>
            <App routes={routes} />
        </BreakpointsProvider>
    </BrowserRouter>
);

AppProvider.propTypes = {
    routes: PropTypes.array.isRequired
};

export default AppProvider;
